module.exports = __webpack_public_path__ + "img/solution_partner_jckh@2x.c5997ed1.png";